<template>
  <div class="layout-header">
    <div class="title" style="width: 200px;">
      <!-- <div class="title" :style="{ width: slideWidth }"> -->
      <div class="inner" @click="goTo_Detail" style="text-align: center; margin-left: -27px; padding-top: 10px;line-height: 24px;">
        蔚动力智慧<br/>充电运营管理平台
      </div>
    </div>
    <i class="icon-class" :class="triggerClass" @click="handleTrigger" />
    <div class="toolbar">
      <div class="company-wrap">
        {{ $t('home.currentCompany') }}：
        <el-cascader
          id="company"
          v-model="activeIndex"
          size="mini"
          placeholder=""
          :options="getTreeDataNull(this.$store.state.login.user)"
          :show-all-levels="false"
          :props="{ checkStrictly: true, emitPath:false, expandTrigger: 'hover', label: 'name', value: 'id' }"
          @change="handleSelect"
        />
      </div>

      <!-- 下面是国际化，暂时用不到先注释掉 -->
      <!--      <el-dropdown @command="switchLanguage">
        <span class="el-dropdown-link d-flexAliCenter">
          <div style="width:26px;height:26px;" />
          <span class="currentLanguage">{{ $t('home.currentLanguage') }}：{{ currentLanguage }}</span>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="简体中文">简体中文</el-dropdown-item>
          <el-dropdown-item command="English">English</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link d-flexAliCenter">
          <img src="../assets/user.png" alt="" style="width:26px;height:26px;">
          <span style="color: #FFFFFF;">{{ userName }}</span>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="修改密码">{{ $t('home.changePassword') }}</el-dropdown-item>
          <el-dropdown-item command="退出登录">{{ $t('home.logOut') }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-dialog title="修改密码" :visible.sync="dialogVisible" width="60%" center>
      <el-form
        ref="uploadPwdForm"
        :model="form"
        :rules="rules"
        label-width="100px"
        style="width: 80%; text-align: center; margin: auto"
      >
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input v-model="form.oldPassword" type="password" />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="form.newPassword" type="password" />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmNewPassword">
          <el-input v-model="form.confirmNewPassword" type="password" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="updatePassword">确定</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import fieldFilter from '@/utils/fieldFilter.js'
import { TreeDataNull } from '@/utils/tool.js'
import router from '@/router'
export default {
  name: 'Header',

  props: ['slideWidth'],
  data() {
    const validateNewPassword = (rule, value, callback) => {
      if (value === this.form.oldPassword) {
        callback(new Error('新密码不能与原密码相同!'))
      } else {
        callback()
      }
    }
    const validateConfirmNewPassword = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error('与新密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      userName: '',
      dialogVisible: false,
      showLogo: true,
      form: {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: ''
      },
      rules: {
        oldPassword: [{
          required: true,
          message: '请输入旧密码',
          trigger: 'blur'
        }],
        newPassword: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        },
        {
          validator: validateNewPassword,
          trigger: 'blur'
        }
        ],
        confirmNewPassword: [{
          required: true,
          message: '请输入确认新密码',
          trigger: 'blur'
        },
        {
          validator: validateConfirmNewPassword,
          trigger: 'blur'
        }
        ]
      },

      triggerType: 'open',
      triggerClass: 'el-icon-s-fold',
      activeIndex: '',
      currentLanguage: '简体中文'
    }
  },
  computed: {

  },
  created: function() {
    this.$store.dispatch('login/getCur')
    this.$store.dispatch('login/getOrg')
    this.$store.dispatch('login/getMenu')
  },
  beforeMount() {
    this.userName = localStorage.getItem('userName')
  },
  mounted() {
    // 查找本地缓存的语言 en zh
    const localLanguage = localStorage.getItem('locale') || 'zh'
    this.currentLanguage = localLanguage === 'zh' ? '简体中文' : 'English'
    setTimeout(() => {
      this.activeIndex = localStorage.getItem('curCompanyId')
    }, 1000)
  },
  methods: {
    goTo_Detail() {
      // this.$router.push({path:"./bigScreen"})
      router.push('/bigScreen')
    },
    getTreeDataNull(data) {
      if (data && data.length > 0) {
        return TreeDataNull(data)
      } else {
        return []
      }
    },
    handleSelect: function(id) {
      this.$store.dispatch('login/changeCompany', {
        companyId: id
      })
    },
    logout: function() {
      this.$confirm('是否要退出系统？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('login/logout')
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出登录'
          })
        })
    },
    handleCommand(command) {
      if (command === '修改密码') {
        this.dialogVisible = true
      } else if (command === '退出登录') {
        this.logout()
      }
    },
    /**
       * 切换使用语言
       */
    switchLanguage(e) {
      console.log(e)
      const localLanguage = e === 'English' ? 'en' : 'zh'
      this.$i18n.locale = localLanguage
      localStorage.setItem('locale', localLanguage)
      this.currentLanguage = e
    },
    handleTrigger: function(e) {
      if (this.triggerType === 'open') {
        this.showLogo = false
        this.triggerType = 'close'
        this.triggerClass = 'el-icon-s-unfold'
      } else {
        this.showLogo = true
        this.triggerType = 'open'
        this.triggerClass = 'el-icon-s-fold'
      }
      // 触发父组件定义的menu-trigger-event自定义事件
      this.$emit('menu-trigger-event', this.triggerType)
    },
    updatePassword: function() {
      const dataForm = this.form
      this.$refs['uploadPwdForm'].validate((valid) => {
        if (valid) {
          const data = fieldFilter.filter(dataForm, [
            'oldPassword',
            'newPassword'
          ])
          this.$store.dispatch('form/handle', {
            url: '/user/login/updatePwd',
            data: data,
            method: 'post',
            callback: (resp) => {
              this.dialogVisible = false
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  @import "./Header.less";
</style>

<style>
  .el-dialog .el-dialog__header {
    /* background: #409eff; */
    background: linear-gradient(90deg, #0d2740, #0a1c2b);
  }

  .el-dialog .el-dialog__header .el-dialog__title {
    font-size: 25px;
    font-weight: bolder;
    color: #fff;
  }

  .el-dialog .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
    font-size: 25px;
    color: #fff;
  }

  .el-dialog .el-dialog__body .el-form .el-form-item .el-form-item__label {
    color: #000;
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue